import {Check} from "@sparkware/app-utils";
import {PropsWithChildren} from "react";
import {MenuItemComponentProps} from "../../../../../services/menu-items-common/menu-item-component-props.interface";
import {IMenuItemRenderer} from "../../../../../services/menu-items-common/renderer/menu-item.renderer.interface";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {AppHeaderCrossBrandItemBox} from "../boxes/app-header-cross-brand-item/app-header-cross-brand-item.box";
import {AppHeaderCrossBrandTextBox} from "../boxes/app-header-cross-brand-text/app-header-cross-brand-text.box";

interface GenericCrossBrandsMenuLinkComponentProps extends MenuItemComponentProps {
    className?: string;
}

export class GenericCrossBrandsMenuItemComponent extends OrbitComponent<PropsWithChildren<GenericCrossBrandsMenuLinkComponentProps>> {
    private _onBrandClick = () => {

        const isAuth = this.services.user.isAuthorized;
        this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", "Cross_" + (isAuth ? "Casino_" : "") + this.props.menuItem.text);
    
        this.props.menuItem.execute();
    };

    
    private _renderIcon = () => {
        const brandConfig: IMenuItemRenderer = this.props.menuItem;

        if (Check.isEmpty(brandConfig?.icon)) {
            return null;
        }

        const Icon = this.services.theme.currentTheme.icons[brandConfig.icon];

        if (Check.isNullOrUndefined(Icon)) {
            return null;
        }

        return <Icon className={`cy-cross-brand-link-icon`} size={3} text={''} title={brandConfig.iconAltText ?? '' } />;
    };


    render() {
        const {key, text} = this.props.menuItem;
        return <AppHeaderCrossBrandItemBox
            menuItemKey={key}
            className={`cy-cross-brand-link ${key}`}
            onClick={() => this._onBrandClick()}
        >
            {this._renderIcon()}
            <AppHeaderCrossBrandTextBox>
                {text}
            </AppHeaderCrossBrandTextBox>
        </AppHeaderCrossBrandItemBox>;
    }
}
